import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component";

const RABillAside = ({ updateSm, sm }: any) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";

  // Get current pathname without query params for comparison
  const pathname = location.pathname;
  const pathWithoutPrefix = pathname.replace(process.env.PUBLIC_URL || "", "");

  // Helper function to check if a route is active
  const isActive = (route: string) => {
    const routePath = route.replace(process.env.PUBLIC_URL || "", "");
    // Exact match
    if (pathWithoutPrefix === routePath) return true;
    // For view pages with IDs, highlight the corresponding list/view page
    if (
      routePath === "/ra-bills-view-approved" &&
      (pathWithoutPrefix.startsWith("/ra-bills-view-details/") ||
        pathWithoutPrefix.startsWith("/ra-bills-approval-details/"))
    )
      return true;
    if (
      routePath === "/ra-bills-create" &&
      pathWithoutPrefix.startsWith("/ra-bills-create-detail/")
    )
      return true;
    return false;
  };

  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">RA Bills</span>
            <span className="sub-text">
              Manage Running Account Bills creation, approvals, and payment
              tracking
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/ra-bills-create`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-create${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-circle" />
              <span>Create RABills</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/ra-bills-pending-approvals`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-pending-approvals${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-round" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/ra-bills-view-approved`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-view-approved${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="eye" />
              <span>View RABills</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/ra-bills-outstanding`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-outstanding${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="clock" />
              <span>Outstanding RABills</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/ra-bills-overdue`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-overdue${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="alert-circle" />
              <span>Overdue RABills</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RABillAside;
